<template>
    <!-- similar to albumLocation-->
    <div id="location">
        <div v-if="error" class="container mtb-80">
            <app-back :title="error"></app-back>
        </div>
        <div v-if="albumLocation">
            <app-header :info="albumLocation.location" :title="capitalize(this.title)" :imagePath="albumLocation.location.imagePath" isType="location"></app-header>
            <div v-if="albumLocation.photos" class="bg-dark1">
                <app-sb :photos="albumLocation.photos" albumId="3"></app-sb>
                <h3 class="links">
                    <router-link to="/galerija">Vse slike </router-link>
                </h3>
            </div>

            <app-google-map :mapName="capitalize(this.title)"></app-google-map>
        </div>
    </div>
</template>

<script>
import { ApiHome } from '../../.env';
import { mapGetters, mapActions } from 'vuex';
import StringsMixin from '../../mixins/StringsMixin';
import HeaderBar from '../../components/layout/HeaderBar.vue';
import GoogleMaps from '../../components/elements/gmaps/GoogleMaps.vue';
import Silentbox from '../../components/elements/silentbox/Silentbox.vue';
import BackButton from '../../components/layout/BackButton.vue';

export default {
    props: ['location'],
    mixins: [StringsMixin],

    data() {
        console.log('location L : ', this.location);
        return {
            endpoint: ApiHome+ 'location/' + this.location,
        }
    },

    components: {
        'app-header': HeaderBar,
        'app-google-map': GoogleMaps,
        'app-sb': Silentbox,
        'app-back': BackButton,
    },

    computed: {
        ...mapGetters([
            'albumLocation',
            'loading',
            'error',
            'title'
        ]),

    },

    methods: {

        fetchLocation() {

            this.$store.dispatch('fetchLocation', this.endpoint);
        },

    },

    created() {
        if(this.albumLocation === null || this.albumLocation.location.slug !== this.location) {

            this.fetchLocation();
        }
        // document.title = this.capitalize(this.location);
        // console.log('General location - Component created.', this.albumLocation, this.location, this.albumLocation)
    },

    beforeUpdate() {
        // console.log('before update location l coming from navbar', this.albumLocation);
    }
}
</script>



// WEBPACK FOOTER //
// src/views/locations/Location.vue